<template>
  <!-- <nav>
    <router-link to="/">FB</router-link> |
    <router-link to="/whatsapp">Whatapp</router-link>
  </nav> -->
  <router-view/>
</template>
